<template>
    <div class="absent_student">
        <div class="card">
            <div class="title">请假未到学生 <van-tag v-if="leaveInfo.isSignIn === 0"  type="success">已补签</van-tag></div>
           

            <div class="group">
                <div class="cell">
                    <label>请假人：</label>
                    <span>{{ info.location }} </span>
                </div>
                <div class="cell">
                    <label>请假开始时间：</label><span>{{ leaveInfo.leaveBeginTime }}</span>
                </div>
                <div class="cell">
                    <label>请假结束时间：</label><span>{{ leaveInfo.leaveEndTime }}</span>
                </div>
                <div class="cell">
                    <label>申请人手机号：</label><span> <a :href="'tel:' + leaveInfo.applicantMobile">{{leaveInfo.applicantMobile}}</a></span>
                </div>
                <!-- 处理分类 -->
              
                
            </div>
          
        </div>
   
        <div style="text-align: center;padding-bottom: 20px;">
            <van-button style="width: 70%" v-if="leaveInfo.isSignIn !== 0" type="info" round @click="handleSignIn()">补签</van-button>
        </div>


     
    </div>
</template>

<script>
import axios from 'axios'
import JSONBig from 'json-bigint'
import store from "@/store";
export default {
    name: "absent-student",
    data() {
        return {
            // 未到校学生信息
            info: {},
            leaveInfo: {},
            params: {
                warningId: '',
                appId: ''
            },
            // 待实现
            classId: '', // 根据classId显示各自班级的未到学生清单 ( 待实现 )
            parentList: ['爸爸', '妈妈', '爷爷', '奶奶', '外婆', '外公', '哥哥', '姐姐', '其他亲属', '伯父', '伯母', '叔叔', '婶婶', '姑父', '姑母', '舅舅', '舅妈', '姨夫', '姨妈', '嫂嫂', '姐夫']
        };
    },

    created() {
        this.params.warningId = this.getParams('warningId')
        this.params.appId = this.getParams('appId')
        this.getStudentList()
    },
    methods: {
        // 获取参数
        getParams(name) {
            console.log(window.location)
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            console.log('r', r)

            return r ? unescape(r[2]) : '';
        },

        // 补签接口
        async handleSignIn(res) {
            const { data, code } = await this.$https.leaveNotInSchoolSignInPlatform({
                warningId: this.params.warningId
            })
            if (code == 200) {
                this.$toast('补签成功')
                this.getStudentList()
            } else {
                this.$toast('补签失败')
            }
        },



        async getStudentList() {
            const { data, code } = await this.$https.getAlarmById({
                id: this.params.warningId
            })
            if (code == 200 && data) {
                console.log('data',data)
                this.info = data
                this.leaveInfo = JSONBig.parse(data.parameter)
            }

        }
    },
};
</script>

<style lang="scss" scope>
.absent_student {
    // position: relative;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    padding-top: 1rem;

    .card {
        background-color: red;

        .title {
            padding: 0.8rem 1rem;
            font-size: 0.8rem;
            color: #969799;

            border-bottom: 1px solid rgba(244, 244, 246, 0.99);
        }

        margin: 0 1rem 1rem;
        background: #fff;
        /* height: 10rem; */
        box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);

        border-radius: 0.75rem;

        .avatar {
            padding: 0;

            .name {
                text-align: center;
                font-size: 0.75rem;
                margin-top: 0.7rem;
                color: #969799;
            }

            .video {
                width: 21rem;
                height: 12rem;
                margin: 1rem auto;
                border-radius: 1rem;

                #mse1 {
                    border-radius: 1rem;
                }
            }
        }

        img {
            width: 21rem;
            height: 12rem;
            border-radius: 1rem;
            margin: 1rem auto;
            display: block;
            object-fit: cover;
        }

        .group {
            font-size: 0.85rem;

            .cell {
                padding: 0.8rem 0;
                border-bottom: 1px solid rgba(244, 244, 246, 0.99);
                margin: 0 1rem;
                display: flex;
                align-items: center;

                &:last-child {
                    border-bottom: none;
                }

                label {
                    width: 7rem;
                    // background-color: red;
                    color: #969799;
                    display: inline-block;
                    font-size: 0.75rem;
                }

            }
        }
    }

    .submit {
        // padding-top:10rpx;
        // padding-bottom:10rpx;
        display: block;
        width: 15rem;
        padding: 0.5rem 0;
        margin: 0 auto;
        background: #37a5da;
        font-size: 1rem;
        border-radius: 1rem;
        text-align: center;
        color: #fff;
    }
}

.success {
    width: 100%;
    height: 2rem;
}
</style>